import { Pipe, PipeTransform } from '@angular/core';
import { MassMenuItemDeleteService } from '../../components/massmenuitemdelete/services/massmenuitemdelete.service';
// import { MassMenuItemDeleteService } from '../../services/massmenuitemdelete.service';

@Pipe({
	name: 'menuLazyLoadFilter'
})

export class MenuLazyLoadFilterPipe implements PipeTransform {
	constructor(
		private massMenuItemDeleteService : MassMenuItemDeleteService
	){}

	transform(items: any, idSearch: any, nameSearch: any, classSearch:any, statusSearch:any, startIndex: any): any{
    	if (items && items.length){
	      	let filtered = false;
	        return items.filter(item =>{
				if(nameSearch && item.menuItemName.toLowerCase().indexOf(nameSearch.toLowerCase()) === -1){
		        	this.massMenuItemDeleteService.filteredStartCount = 0;
		            this.massMenuItemDeleteService.originalStartCount = 0;
		            return false;
		        }
		        if(idSearch && item.menuItemCode.toString().indexOf(idSearch.toString()) === -1) {
					this.massMenuItemDeleteService.filteredStartCount = 0;
					this.massMenuItemDeleteService.originalStartCount = 0;
					return false;
				}
		        if(classSearch && item.menuItemClass.toLowerCase().indexOf(classSearch.toLowerCase()) === -1){
					this.massMenuItemDeleteService.filteredStartCount = 0;
					this.massMenuItemDeleteService.originalStartCount = 0;
					return false;
				}
				
				if(statusSearch == "All"){
					return true;
				} else if(statusSearch && item.menuItemStatus.toLowerCase() !== (statusSearch.toLowerCase())){
					this.massMenuItemDeleteService.filteredStartCount = 0;
					this.massMenuItemDeleteService.originalStartCount = 0;
					return false;
				}
				
		        return true;
			});
	    } else {
	        return items;
	    }
	}

}